module.exports = __webpack_public_path__ + "static/logo-9ef871a47c5ad7fa2e5d8a7e61c8dffa.png";